import { createContext, type ReactNode, useContext, useEffect } from 'react';

type DocumentPollingContextValue = {
    setIsDocumentDialogOpen: (isDialogOpen: boolean) => void;
};

const DocumentPollingContext = createContext<DocumentPollingContextValue | null>(null);

type DocumentPollingProviderProps = {
    children: ReactNode;
    setIsDocumentDialogOpen: (isDialogOpen: boolean) => void;
};

export const DocumentPollingProvider = ({ children, setIsDocumentDialogOpen }: DocumentPollingProviderProps) => {
    useEffect(() => {
        return () => {
            setIsDocumentDialogOpen(false);
        };
    }, [setIsDocumentDialogOpen]);

    return <DocumentPollingContext value={{ setIsDocumentDialogOpen }}>{children}</DocumentPollingContext>;
};

const useDocumentPollingContext = () => {
    const context = useContext(DocumentPollingContext);

    if (!context) {
        throw new Error('useDocumentPollingContext must be used within a DocumentPollingProvider');
    }
    return context;
};

export const useStopsPollingWhileMounted = (isOpen = true) => {
    const { setIsDocumentDialogOpen } = useDocumentPollingContext();

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setIsDocumentDialogOpen(true);
        return () => setIsDocumentDialogOpen(false);
    }, [isOpen, setIsDocumentDialogOpen]);
};
